import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "sweetalert2/dist/sweetalert2.min.css";
import VueSweetalert2 from "vue-sweetalert2";
import VuetifyMask from "vuetify-mask";
import JsonExcel from "vue-json-excel";
import VueZoomer from "vue-zoomer";
import VueMask from "v-mask";
import VueTheMask from "vue-the-mask";
import device from 'vue-device-detector'
import { initPushServiceWorker } from './utils/pushSubscription'

initPushServiceWorker()

const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};

Vue.component("downloadExcel", JsonExcel);
Vue.use(VueMask);
Vue.use(VueTheMask)
Vue.use(VueSweetalert2, options);
Vue.use(VuetifyMask);
Vue.use(VueZoomer);
Vue.use(device)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
